"use client";

import { useTranslations } from "next-intl";
import React, { useEffect, useRef, useState } from "react";
import { InfoTooltip } from "@/components/common/info-tooltip";
import type {
  DietCalorificsMealTypesType,
  DietCatalogDetail,
} from "@/features/diets/types";

export const MealsButton = ({
  item,
  diet,
  kcal,
  showCalorifics = false,
}: {
  item: DietCalorificsMealTypesType;
  diet: DietCatalogDetail;
  kcal: number;
  showCalorifics?: boolean;
}) => {
  const t = useTranslations();
  const currentCalorifics = diet.calorifics.find(
    (c) => c.calories === Number(kcal),
  );
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const meals = currentCalorifics?.mealsCaloricValue?.find(
    (m) => m.mealId === item.mealId,
  );

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const truncated = el.scrollWidth > el.clientWidth;
      setIsTruncated(truncated);
    }
  }, []);

  return (
    <div className="flex flex-1 justify-between truncate md:block">
      <p
        className="truncate font-medium text-base text-brand-green2-300 capitalize"
        ref={textRef}
      >
        {isTruncated ? (
          <InfoTooltip asChild content={item.name}>
            <span>{item.name}</span>
          </InfoTooltip>
        ) : (
          item.name
        )}
      </p>
      {showCalorifics && (
        <p className="mt-0.5 shrink-0 text-brand-green2 text-sm md:mt-0">
          {t("cart.configuration.calorifics", {
            kcal: meals?.caloricity?.toString() ?? "0",
          })}
        </p>
      )}
    </div>
  );
};
